// Get the base URL for API calls
const getApiBaseUrl = () => {
    // In production, use the actual domain
    if (process.env.NODE_ENV === 'production') {
        return 'https://www.disruptioncontents.tokyo';
    }

    // In development, use localhost with the WordPress port
    // This reads from REACT_APP_DEV environment variable or defaults to localhost:8000
    const devUrl = process.env.REACT_APP_DEV || 'localhost:8000';
    return `http://${devUrl}`;
};

export const API_BASE_URL = getApiBaseUrl();
export const WP_API_URL = `${API_BASE_URL}/wp-json/wp/v2`;

// Helper function to build WordPress API URLs
export const buildWpApiUrl = (endpoint, params = {}) => {
    const url = new URL(`${WP_API_URL}/${endpoint}`);
    Object.keys(params).forEach(key =>
        url.searchParams.append(key, params[key])
    );
    return url.toString();
};